import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGrid"><Path fillRule="evenodd" clipRule="evenodd" d="M9.25 7.75H14.75V3H16.25V7.75H21V9.25H16.25V14.75H21V16.25H16.25V21H14.75V16.25H9.25V21H7.75V16.25H3V14.75H7.75V9.25H3V7.75H7.75V3H9.25V7.75ZM9.25 14.75H14.75V9.25H9.25V14.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGrid;
